import { createFileRoute } from '@tanstack/react-router';
import { VoiceScanPage } from '../components/scan/VoiceScanPage.tsx';

export const Route = createFileRoute('/_app/scan/voice')({
  component: VoiceScanPage,
});
